export enum CommentTags {
    Comment = 'Comment',
    Attachment = 'Attachment',
}